import { render, staticRenderFns } from "./ClientPropertyHandler.vue?vue&type=template&id=c3d2da10&scoped=true&"
import script from "./ClientPropertyHandler.vue?vue&type=script&lang=js&"
export * from "./ClientPropertyHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d2da10",
  null
  
)

export default component.exports